/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by richardwilliams on 5/28/15,
 * Refactored by kyang on 10/2/19.
 */

function PackageStatusBarController(
    this: JS5Object,
    $routeParams: JS5Object,
    $scope: JS5Object,
    ModalService: JS5Object,
    PermissionsService: JS5Object
) {
    let APPROVAL_VIEW_STATE = 'PACKAGE_APPROVE_REJECT_VIEW_STATE';


    //==============//
    // Errors Modal //
    //==============//

    this.showErrorsWarningsButton = () => {
        return this.packageObject.validationResult && this.packageObject.validationResult.length;
    };

    this.showErrorsWarningsModal = () => {
        ModalService.showErrorsWarningsModal(this.packageObject.validationResult, this.packageObject.name);
    };


    //==================//
    // Approval Buttons //
    //==================//

    this.showApprovalButtons = () => {
        return !this.packageObject.acceptStatus &&
            this.packageObject.metadataErrorCount === '0' &&
            this.packageObject.mediaErrorCount === '0' &&
            (this.packageObject.primaryVideo &&
            this.packageObject.primaryVideo.proxyId);
    };

    this.showApprovalText = () => {
        return !this.showApprovalButtons();
    };

    this.showRejectedButton = () => {
        return this.packageObject.acceptStatus === 'REJECTED';
    };

    this.openRejectionModal = () => {
        ModalService.showRejectPackageModal(this.packageObject.rejectReason);
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    const getApprovePermissions = () => {
        PermissionsService.canWritePackage(APPROVAL_VIEW_STATE, $routeParams.id)
        .then((perms: boolean) => {
            this.approvalPermitted = perms;
        });
    };

    this.$onInit = () => {
        this.approvalPermitted = false;
        getApprovePermissions();
    };
}


angular.module('prism-ui.package').component(
    'packageStatusBar',
    {
        bindings: {
            packageObject: '=',
            acceptHandler: '&',
            rejectHandler: '&'
        },
        controller: PackageStatusBarController,
        templateUrl: 'package/editor/components/view/statusbar/packagestatus-bar-template.html',
    });
